import React, { useState } from 'react';

interface SpendingInputProps {
  onSpendingTargetChanged: (spendingTarget: number) => void;
}

const SpendingInput: React.FC<SpendingInputProps> = ({ onSpendingTargetChanged: onWithdrawalChange }) => {
  const [monthlySpending, setMonthlySpending] = useState<number>(0);

  const handleSpendingChange = (value: string) => {
    const numValue = parseFloat(value) || 0;
    setMonthlySpending(numValue);
    onWithdrawalChange(numValue);
  };

  return (
    <div className="spending-input">
      <h2>Spending</h2>
      
      <div className="input-group">
        <label htmlFor="monthlySpending">Starting Monthly Spending Target ($):</label>
        <input
          id="monthlySpending"
          type="number"
          value={monthlySpending}
          onChange={(e) => handleSpendingChange(e.target.value)}
          placeholder="Enter monthly spending amount"
          min="0"
          step="100"
        />
        <small>Amount to spend each month. Will be adjusted for inflation.</small>
      </div>
    </div>
  );
};

export default SpendingInput;
